import {FC, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {AppDispatch, RootState} from '../../../../../redux/store'
import Table from '../../common/Table'
import TableHeader from '../../common/TableHeader'
import {getClientWalletListApi} from '../../../../../redux/slices/ClientWalletSlice'
import {toast} from 'react-toastify'

const ClientWalletTable: FC = () => {
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchKey, setSearchKey] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  const clientWalletData = useSelector(
    (state: RootState) => state.clientWallet.ClientWalletList?.data || []
  )
  const clientWalletTotal = useSelector(
    (state: RootState) => state.clientWallet.ClientWalletList?.total || 0
  )

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedSearchQuery(searchKey)
    }, 1000)

    return () => clearTimeout(debounceTimeout)
  }, [searchKey])

  const fetchClientWalletList = () => {
    setLoading(true)
    dispatch(
      getClientWalletListApi({
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        filterkey: debouncedSearchQuery,
      })
    )
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
        toast.error('Failed to fetch client wallet data')
      })
  }

  useEffect(() => {
    fetchClientWalletList()
  }, [currentPage, rowsPerPage, debouncedSearchQuery])

  const handleSearchChange = (searchQuery: string) => {
    setSearchKey(searchQuery)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setCurrentPage(page)
    setRowsPerPage(newPerPage)
  }

  const columnData = [
    {name: 'Name', selector: (row: any) => row?.name, sortable: true},
    {name: 'Email', selector: (row: any) => row?.email, sortable: true},
    {
      name: 'Organization',
      selector: (row: any) => row?.organizationDetails?.name,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: (row: any) => new Date(row?.createdAt).toLocaleDateString(),
      sortable: true,
    },
  ]

  return (
    <div className='card'>
      <TableHeader search={searchKey} handleSearchChange={handleSearchChange} showFilter={false} />

      <div className='card-body p-0 shadow-sm'>
        <Table
          data={clientWalletData}
          columns={columnData}
          isLoading={loading}
          handlePerRowsChange={handlePerRowsChange}
          handlePageChange={handlePageChange}
          totalRows={clientWalletTotal}
          showPagination={true}
        />
      </div>
    </div>
  )
}

export default ClientWalletTable
